import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { apiFetch } from "../../api/setupAxios";

// Panel de NOTIFICACIONES (superadmin → Gestionar datos): todos los dispositivos
// registrados, con qué usuario(s) y si reciben avisos, y la situación de cada
// asistenta / supervisora / comprador activo (activas, desactivadas, sin activar).

const SITUACION = {
  activas: { txt: "Activas", icono: "🔔", fg: "#15803d", bg: "#dcfce7", borde: "#86efac" },
  // dice activas, pero su móvil informa de que no consigue suscribirse (le fallan)
  fallan: { txt: "Fallan en el móvil", icono: "⚠️", fg: "#b45309", bg: "#fef3c7", borde: "#fcd34d" },
  desactivadas: { txt: "Desactivadas", icono: "🔕", fg: "#b91c1c", bg: "#fee2e2", borde: "#fca5a5" },
  sin_activar: { txt: "Sin activar", icono: "⚪", fg: "#475569", bg: "#f1f5f9", borde: "#cbd5e1" },
};
const ESTADO_DISP = {
  1: { txt: "Recibe avisos", icono: "🔔", fg: "#15803d", bg: "#dcfce7" },
  0: { txt: "Desactivadas por la persona", icono: "🔕", fg: "#b91c1c", bg: "#fee2e2" },
  2: { txt: "Registro antiguo (inactivo)", icono: "💤", fg: "#64748b", bg: "#f1f5f9" },
};
// Cuándo se activaron (fecha_creacion) y, si las desactivaron, cuándo (fecha_baja).
// Las bajas anteriores al 09/10/2026 no tienen fecha (no se guardaba).
const FechasAltaBaja = ({ estado, alta, baja }) => (
  <div style={{ fontSize: 11.5, marginTop: 2, display: "flex", gap: 10, flexWrap: "wrap" }}>
    {alta && <span style={{ color: estado === 1 ? "#15803d" : "#64748b" }}>🔔 {estado === 1 ? "Activadas" : "Activadas antes"} el {fmt(alta)}</span>}
    {estado === 0 && <span style={{ color: "#b91c1c", fontWeight: 700 }}>🔕 Desactivadas {baja ? `el ${fmt(baja)}` : "(fecha desconocida)"}</span>}
    {estado === 1 && baja && <span style={{ color: "#94a3b8" }}>· última baja {fmt(baja)}</span>}
  </div>
);

const TIPOS = [["todos", "Todos"], ["supervisora", "Supervisoras"], ["asistenta", "Asistentas"], ["comprador", "Compradores"]];
const fmt = (iso) => (iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)} ${iso.slice(11, 16)}` : "—");

const Chip = ({ c, extra }) => (
  <span style={{ display: "inline-flex", alignItems: "center", gap: 4, background: c.bg, color: c.fg, borderRadius: 999, padding: "2px 10px", fontSize: 12.5, fontWeight: 800, whiteSpace: "nowrap" }}>
    {c.icono} {c.txt}{extra ? ` · ${extra}` : ""}
  </span>
);

// Confirmación en rojo para quitar / activar avisos
function ConfirmRojo({ accion, u, d, onCancelar, onHecho }) {
  const [enviando, setEnviando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const quitar = accion === "quitar";
  const confirmar = async () => {
    setEnviando(true);
    try {
      const r = await apiFetch("/device-notifs/panel/estado", {
        method: "POST", credentials: "include", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user: u.user, device_id: d.device_id, accion }),
      });
      const j = await r.json().catch(() => ({}));
      setResultado({ ok: r.ok && j.ok, texto: j.mensaje || j.error || `Error ${r.status}` });
      if (r.ok && j.ok) onHecho();
    } catch (_) {
      setResultado({ ok: false, texto: "No se pudo conectar con el servidor." });
    }
    setEnviando(false);
  };
  return (
    <div onClick={onCancelar} style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.6)", zIndex: 5000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: "#fff", borderRadius: 18, border: "4px solid #dc2626", width: "min(460px, 100%)", padding: "18px 18px 14px", textAlign: "center", boxShadow: "0 20px 50px rgba(0,0,0,0.35)" }}>
        <div style={{ fontSize: 42 }}>{quitar ? "🔕" : "🔔"}</div>
        <div style={{ fontSize: 19, fontWeight: 900, color: "#b91c1c", marginTop: 4 }}>
          {quitar ? "¿Quitar los avisos?" : "¿Activar los avisos?"}
        </div>
        <div style={{ fontSize: 15, color: "#7f1d1d", fontWeight: 600, margin: "10px 0 6px", lineHeight: 1.45 }}>
          <b>{u.nombre || u.user}</b> (@{u.user}) en el móvil <b>{d.modelo || d.device_id.slice(0, 8)}</b>.
        </div>
        <div style={{ fontSize: 13.5, color: "#991b1b", marginBottom: 14, lineHeight: 1.45 }}>
          {quitar
            ? "Dejarán de llegarle al móvil los avisos de cambios en sus pisos y de compras. En su app le saldrá el aviso para volver a activarlos."
            : "Se reactivan en ese móvil y se le manda un aviso de comprobación («🔔 Avisos activados»). Si su móvil ya no los acepta (desinstaló la app, borró los datos o quitó el permiso), tendrá que activarlos ella desde su móvil."}
        </div>
        {resultado ? (
          <>
            <div style={{ background: resultado.ok ? "#dcfce7" : "#fee2e2", color: resultado.ok ? "#14532d" : "#991b1b", borderRadius: 10, padding: 10, fontWeight: 700, marginBottom: 10 }}>
              {resultado.ok ? "✅ " : "⚠️ "}{resultado.texto}
            </div>
            <button onClick={onCancelar} style={{ width: "100%", border: "none", borderRadius: 12, padding: "11px 0", background: "#334155", color: "#fff", fontWeight: 800, cursor: "pointer" }}>Cerrar</button>
          </>
        ) : (
          <>
            <button onClick={confirmar} disabled={enviando} style={{ width: "100%", border: "none", borderRadius: 12, padding: "12px 0", background: "#dc2626", color: "#fff", fontWeight: 900, fontSize: 16, cursor: "pointer", marginBottom: 8, opacity: enviando ? 0.6 : 1 }}>
              {enviando ? "…" : quitar ? "Sí, quitar los avisos" : "Sí, activar los avisos"}
            </button>
            <button onClick={onCancelar} disabled={enviando} style={{ width: "100%", border: "2px solid #cbd5e1", borderRadius: 12, padding: "10px 0", background: "#fff", color: "#334155", fontWeight: 800, cursor: "pointer" }}>Cancelar</button>
          </>
        )}
      </div>
    </div>
  );
}

// Nombre del móvil ("titular"): añadir / editar / borrar (borrar con confirmación en rojo)
function Titular({ d, onCambiado }) {
  const [editando, setEditando] = useState(false);
  const [texto, setTexto] = useState(d.titular || "");
  const [guardando, setGuardando] = useState(false);
  const [confirmarBorrar, setConfirmarBorrar] = useState(false);
  const guardar = async (valor) => {
    setGuardando(true);
    try {
      const r = await apiFetch("/device-notifs/panel/titular", {
        method: "POST", credentials: "include", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ device_id: d.device_id, titular: valor }),
      });
      if (r.ok) { setEditando(false); setConfirmarBorrar(false); onCambiado(); }
      else window.alert("No se pudo guardar el nombre.");
    } catch (_) { window.alert("No se pudo guardar el nombre."); }
    setGuardando(false);
  };
  if (editando) {
    return (
      <div style={{ display: "flex", gap: 6, alignItems: "center", marginBottom: 6 }}>
        <input autoFocus value={texto} maxLength={100} onChange={(e) => setTexto(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter" && texto.trim()) guardar(texto); if (e.key === "Escape") setEditando(false); }}
          placeholder="Nombre del móvil (p. ej. Móvil de Sandra Orna)"
          style={{ flex: 1, minWidth: 0, padding: "7px 10px", borderRadius: 10, border: "2px solid #93c5fd", fontSize: 14, outline: "none" }} />
        <button onClick={() => guardar(texto)} disabled={guardando || !texto.trim()} style={{ ...st.mini, borderColor: "#86efac", color: "#15803d" }}>💾 Guardar</button>
        <button onClick={() => { setEditando(false); setTexto(d.titular || ""); }} style={st.mini}>✕</button>
      </div>
    );
  }
  return (
    <div style={{ display: "flex", gap: 6, alignItems: "center", marginBottom: 6, flexWrap: "wrap" }}>
      {d.titular ? (
        <>
          <span style={{ fontSize: 16, fontWeight: 900, color: "#1e3a5f" }}>📛 {d.titular}</span>
          <button onClick={() => { setTexto(d.titular); setEditando(true); }} style={st.mini}>✏️ Editar</button>
          <button onClick={() => setConfirmarBorrar(true)} style={{ ...st.mini, borderColor: "#fca5a5", color: "#b91c1c" }}>🗑️ Borrar</button>
        </>
      ) : (
        <button onClick={() => { setTexto(""); setEditando(true); }} style={{ ...st.mini, borderStyle: "dashed" }}>➕ Añadir nombre</button>
      )}
      {confirmarBorrar && (
        <div onClick={() => setConfirmarBorrar(false)} style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.6)", zIndex: 5000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
          <div onClick={(e) => e.stopPropagation()} style={{ background: "#fff", borderRadius: 18, border: "4px solid #dc2626", width: "min(420px, 100%)", padding: 18, textAlign: "center" }}>
            <div style={{ fontSize: 40 }}>🗑️</div>
            <div style={{ fontSize: 18, fontWeight: 900, color: "#b91c1c", margin: "4px 0 8px" }}>¿Borrar el nombre del móvil?</div>
            <div style={{ fontSize: 14.5, color: "#7f1d1d", marginBottom: 14 }}>«<b>{d.titular}</b>» · {d.modelo || `móvil ${d.device_id.slice(0, 8)}`}. Solo se borra el nombre; el móvil y sus avisos no cambian.</div>
            <button onClick={() => guardar("")} disabled={guardando} style={{ width: "100%", border: "none", borderRadius: 12, padding: "11px 0", background: "#dc2626", color: "#fff", fontWeight: 900, fontSize: 15.5, cursor: "pointer", marginBottom: 8 }}>{guardando ? "…" : "Sí, borrar el nombre"}</button>
            <button onClick={() => setConfirmarBorrar(false)} style={{ width: "100%", border: "2px solid #cbd5e1", borderRadius: 12, padding: "9px 0", background: "#fff", fontWeight: 800, cursor: "pointer" }}>Cancelar</button>
          </div>
        </div>
      )}
    </div>
  );
}

const infoMovil = (d) => [d.modelo, d.sistema, d.navegador, d.instalada == null ? null : d.instalada ? "App instalada" : "Desde el navegador"].filter(Boolean).join(" · ");

// Página «Ubicación y cámara (fichajes)»: cómo les han funcionado a cada asistenta/supervisora en los últimos 30 días.
// El servidor no ve los permisos del móvil: lo deduce de sus fichajes (QR leído = cámara OK; «sin ubicación» = ubicación fallida).
function PaginaFichajes({ recarga }) {
  const [datos, setDatos] = useState(null);
  const [error, setError] = useState("");
  const [tipo, setTipo] = useState("todos");
  const [busca, setBusca] = useState("");
  const [soloSin, setSoloSin] = useState(false);     // sin ubicación/cámara para fichar
  useEffect(() => {
    setError("");
    axios.get("/api/fichajes/panel")
      .then((r) => setDatos(r.data?.usuarios || []))
      .catch(() => setError("No se pudieron cargar los fichajes."));
  }, [recarga]);
  const q = busca.trim().toLowerCase();
  // «sin ubicación/cámara»: le ha fallado la ubicación al fichar o aún no ha fichado nunca (no se ha podido comprobar)
  const sinPermiso = (u) => u.total === 0 || u.sin_ubicacion > 0;
  const lista = (datos || []).filter((u) => (tipo === "todos" || u.tipo === tipo) && (!soloSin || sinPermiso(u)) && (!q || `${u.user} ${u.nombre}`.toLowerCase().includes(q)));
  const estadoUbic = (u) => {
    if (!u.total) return { txt: "Sin fichajes", icono: "⚪", fg: "#475569", bg: "#f1f5f9" };
    if (u.sin_ubicacion === u.total) return { txt: "Nunca ha funcionado", icono: "⛔", fg: "#b91c1c", bg: "#fee2e2" };
    if (u.sin_ubicacion) return { txt: `Falla ${u.sin_ubicacion} de ${u.total}`, icono: "⚠️", fg: "#b45309", bg: "#fef3c7" };
    return { txt: u.precision_media != null ? `Funciona · ±${u.precision_media} m` : "Funciona", icono: "✅", fg: "#15803d", bg: "#dcfce7" };
  };
  return (
    <div style={{ padding: "14px 16px", maxWidth: 1300, margin: "0 auto" }}>
      {error && <div style={{ background: "#fee2e2", color: "#991b1b", borderRadius: 10, padding: 12, marginBottom: 12 }}>{error}</div>}
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 10 }}>
        {TIPOS.filter(([k]) => k !== "comprador").map(([k, t]) => (
          <button key={k} onClick={() => setTipo(k)} style={{ ...st.pill, ...(tipo === k ? st.pillOn : {}) }}>{t}</button>
        ))}
        <span style={{ width: 1, height: 26, background: "#cbd5e1", margin: "0 4px" }} />
        <button onClick={() => setSoloSin((v) => !v)} style={{ ...st.pill, ...(soloSin ? { background: "#b91c1c", color: "#fff", borderColor: "#b91c1c" } : { borderColor: "#fca5a5", color: "#b91c1c" }) }}>
          ⚠️ Sin ubicación/cámara para fichar{datos ? ` (${datos.filter((u) => (tipo === "todos" || u.tipo === tipo) && sinPermiso(u)).length})` : ""}
        </button>
      </div>
      <input value={busca} onChange={(e) => setBusca(e.target.value)} placeholder="🔍 Buscar usuario o nombre…"
        style={{ width: "100%", boxSizing: "border-box", padding: "10px 14px", borderRadius: 12, border: "2px solid #c7d2fe", fontSize: 14, outline: "none", marginBottom: 12 }} />
      {!datos && !error && <div style={{ textAlign: "center", padding: 40, color: "#64748b" }}>Cargando…</div>}
      {datos && (
        <div style={{ background: "#fff", borderRadius: 14, overflowX: "auto", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14, minWidth: 620 }}>
            <thead>
              <tr style={{ background: "#3498db", color: "#fff" }}>
                {["Usuario", "Tipo", "📍 Ubicación", "📷 Cámara", "Fichajes (30 días)", "Último"].map((h) => <th key={h} style={st.th}>{h}</th>)}
              </tr>
            </thead>
            <tbody>
              {lista.length === 0 ? (
                <tr><td colSpan={6} style={{ padding: 30, textAlign: "center", color: "#94a3b8" }}>No hay usuarios en este filtro.</td></tr>
              ) : lista.map((u, i) => (
                <tr key={u.user} style={{ background: i % 2 ? "#fafafa" : "#fff", borderBottom: "1px solid #eef2f7" }}>
                  <td style={st.td}><strong>{u.nombre || u.user}</strong><div style={{ fontSize: 12, color: "#64748b" }}>@{u.user}</div></td>
                  <td style={{ ...st.td, textTransform: "capitalize" }}>{u.tipo}</td>
                  <td style={st.td}><Chip c={estadoUbic(u)} /></td>
                  <td style={st.td}>{u.total ? <Chip c={{ txt: "Funciona", icono: "✅", fg: "#15803d", bg: "#dcfce7" }} /> : <Chip c={{ txt: "Sin comprobar", icono: "⚪", fg: "#475569", bg: "#f1f5f9" }} />}</td>
                  <td style={{ ...st.td, fontSize: 12.5, color: "#475569" }}>
                    {u.total ? `${u.total} · dentro ${u.dentro} · fuera ${u.fuera}${u.qr_desconocido ? ` · QR desconocido ${u.qr_desconocido}` : ""}${u.tardia ? ` · ubicación tardía ${u.tardia}` : ""}` : "—"}
                    {u.motivos && Object.keys(u.motivos).length > 0 && <div style={{ color: "#b45309" }}>{Object.entries(u.motivos).map(([k, n]) => `${{ denegada: "permiso denegado", no_disponible: "no disponible", tiempo_agotado: "GPS lento", sin_soporte: "sin soporte" }[k] || k} ${n}`).join(" · ")}</div>}
                  </td>
                  <td style={{ ...st.td, fontSize: 12.5, whiteSpace: "nowrap", color: u.ultimo ? "#334155" : "#94a3b8" }}>{u.ultimo ? fmt(u.ultimo) : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <div style={{ fontSize: 12, color: "#64748b", marginTop: 10 }}>Se deduce de los fichajes: el servidor no ve los permisos del móvil. «Sin comprobar» = aún no ha fichado.</div>
    </div>
  );
}

export default function SuperAdminNotificaciones() {
  const navigate = useNavigate();
  const [datos, setDatos] = useState(null);
  const [error, setError] = useState("");
  const [vista, setVista] = useState("usuarios");
  const [pagina, setPagina] = useState("notif");     // notif | fichajes
  const [recargaFich, setRecargaFich] = useState(0);
  const [tipo, setTipo] = useState("todos");
  const [situacion, setSituacion] = useState("todas");
  const [busca, setBusca] = useState("");
  // filtro por fecha de alta (activación) o de baja (desactivación) y orden
  const [campoFecha, setCampoFecha] = useState("alta");
  const [dia, setDia] = useState("");       // un día (o el inicio del rango)
  const [rango, setRango] = useState(false); // con rango aparece la segunda fecha
  const [hasta, setHasta] = useState("");
  const [orden, setOrden] = useState("defecto"); // "campo_asc|desc" o "defecto"
  const [confirmar, setConfirmar] = useState(null); // {accion, u, d}

  const cargar = () => {
    setError("");
    apiFetch("/device-notifs/panel", { credentials: "include" })
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then(setDatos)
      .catch(() => setError("No se pudieron cargar las notificaciones."));
  };
  useEffect(cargar, []);

  const usuarios = useMemo(() => datos?.usuarios || [], [datos]);
  const dispositivos = useMemo(() => datos?.dispositivos || [], [datos]);
  const q = busca.trim().toLowerCase();
  const coincide = (...v) => !q || v.some((x) => x && String(x).toLowerCase().includes(q));

  // fechas de un usuario (vista usuarios) o de un móvil (la más reciente de sus usuarios)
  const fechasDe = (x) => (x.usuarios
    ? { alta: x.usuarios.reduce((m, u) => (u.fecha && (!m || u.fecha > m) ? u.fecha : m), null),
        baja: x.usuarios.reduce((m, u) => (u.fecha_baja && (!m || u.fecha_baja > m) ? u.fecha_baja : m), null) }
    : { alta: x.fecha_alta, baja: x.fecha_baja });
  const filtrandoFecha = !!dia;
  const filtraFecha = (x) => {
    if (!dia) return true;
    const f = fechasDe(x)[campoFecha];
    if (!f) return false;
    const d = f.slice(0, 10);
    if (rango && hasta) return d >= (dia < hasta ? dia : hasta) && d <= (dia < hasta ? hasta : dia);
    return d === dia;
  };
  // valor por el que se ordena cada columna (los vacíos van siempre al final)
  const VALOR_ORDEN = {
    nombre: (x) => String(x.nombre || x.titular || x.user || x.device_id || "").toLowerCase(),
    tipo: (x) => x.tipo || null,
    situacion: (x) => ["fallan", "activas", "desactivadas", "sin_activar"].indexOf(x.situacion),
    alta: (x) => fechasDe(x).alta,
    baja: (x) => fechasDe(x).baja,
    moviles: (x) => (x.moviles || null),
  };
  const ordena = (lista, porDefecto) => {
    if (orden === "defecto") return porDefecto ? lista.sort(porDefecto) : lista;
    const [campo, sentido] = orden.split("_");
    const val = VALOR_ORDEN[campo];
    return lista.sort((a, b) => {
      const va = val(a), vb = val(b);
      const vaciaA = va === null || va === undefined || va === "", vaciaB = vb === null || vb === undefined || vb === "";
      if (vaciaA && vaciaB) return 0;
      if (vaciaA) return 1;
      if (vaciaB) return -1;
      const r = typeof va === "number" ? va - vb : String(va).localeCompare(String(vb), "es");
      return sentido === "desc" ? -r : r;
    });
  };
  // pulsar la cabecera: ordena por esa columna; otra vez, al revés
  const pulsarCabecera = (campo) => {
    const [c, s2] = orden.split("_");
    if (c === campo) setOrden(`${campo}_${s2 === "asc" ? "desc" : "asc"}`);
    else setOrden(`${campo}_${["alta", "baja", "moviles"].includes(campo) ? "desc" : "asc"}`);
  };
  const flecha = (campo) => (orden.split("_")[0] === campo ? (orden.endsWith("_asc") ? " ▲" : " ▼") : "");

  const conteo = useMemo(() => {
    const m = { activas: 0, fallan: 0, desactivadas: 0, sin_activar: 0 };
    usuarios.filter((u) => tipo === "todos" || u.tipo === tipo).forEach((u) => { m[u.situacion] += 1; });
    return m;
  }, [usuarios, tipo]);

  const listaUsuarios = useMemo(() => ordena(usuarios
    .filter((u) => (tipo === "todos" || u.tipo === tipo) && (situacion === "todas" || (situacion === "sin" ? u.situacion !== "activas" : u.situacion === situacion)) && coincide(u.user, u.nombre) && filtraFecha(u)),
    (a, b) => ["fallan", "activas", "desactivadas", "sin_activar"].indexOf(a.situacion) - ["fallan", "activas", "desactivadas", "sin_activar"].indexOf(b.situacion) || String(a.nombre || a.user).localeCompare(String(b.nombre || b.user), "es")),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [usuarios, tipo, situacion, q, campoFecha, dia, rango, hasta, orden]);

  const listaDispositivos = useMemo(() => ordena(dispositivos
    .filter((d) => coincide(d.device_id, d.titular, d.servicio, d.modelo, d.sistema, d.navegador, ...d.usuarios.flatMap((u) => [u.user, u.nombre]))
      && (tipo === "todos" || d.usuarios.some((u) => u.tipo === tipo)) && filtraFecha(d))),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [dispositivos, tipo, q, campoFecha, dia, rango, hasta, orden]);

  const compartidos = dispositivos.filter((d) => d.usuarios.filter((u) => u.estado === 1).length > 1).length;

  return (
    <div style={{ minHeight: "100vh", background: "#f1f5f9", fontFamily: "Segoe UI, sans-serif" }}>
      <div style={{ background: "#1e3a5f", color: "#fff", padding: "14px 18px", display: "flex", alignItems: "center", gap: 12 }}>
        <button onClick={() => navigate(-1)} style={st.btnCab}>← Volver</button>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 13, opacity: 0.7 }}>Gestionar datos</div>
          <strong style={{ fontSize: 20 }}>🔐 Permisos</strong>
        </div>
        <button onClick={pagina === "fichajes" ? () => setRecargaFich((n) => n + 1) : cargar} style={st.btnCab}>↻ Actualizar</button>
      </div>

      <div style={{ display: "flex", gap: 8, padding: "12px 16px 0", maxWidth: 1300, margin: "0 auto" }}>
        {[["notif", "🔔 Notificaciones"], ["fichajes", "📍 Ubicación y cámara (fichajes)"]].map(([k, t]) => (
          <button key={k} onClick={() => setPagina(k)} style={{ ...st.pill, flex: 1, padding: "10px 8px", fontSize: 14.5, ...(pagina === k ? st.pillOn : {}) }}>{t}</button>
        ))}
      </div>

      {pagina === "fichajes" && <PaginaFichajes recarga={recargaFich} />}
      {confirmar && <ConfirmRojo {...confirmar} onCancelar={() => setConfirmar(null)} onHecho={cargar} />}
      <div style={{ padding: "14px 16px", maxWidth: 1300, margin: "0 auto", display: pagina === "notif" ? "block" : "none" }}>
        {error && <div style={{ background: "#fee2e2", color: "#991b1b", borderRadius: 10, padding: 12, marginBottom: 12 }}>{error}</div>}

        {/* Resumen (filtra por situación) */}
        <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 12 }}>
          {[["todas", { txt: "Todos", icono: "👥", fg: "#3730a3", bg: "#eef2ff", borde: "#c7d2fe" }, conteo.activas + conteo.fallan + conteo.desactivadas + conteo.sin_activar],
            ...Object.entries(SITUACION).map(([k, c]) => [k, c, conteo[k]])].map(([k, c, n]) => (
            <button key={k} onClick={() => { setSituacion(k); setVista("usuarios"); }} style={{
              display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 2, minWidth: 140, padding: "10px 14px", borderRadius: 14, cursor: "pointer",
              background: situacion === k && vista === "usuarios" ? c.bg : "#fff", border: `2px solid ${situacion === k && vista === "usuarios" ? c.fg : "#e2e8f0"}`,
            }}>
              <span style={{ fontSize: 12.5, fontWeight: 700, color: c.fg }}>{c.icono} {k === "todas" ? "Usuarios" : c.txt}</span>
              <span style={{ fontSize: 24, fontWeight: 900, color: "#1e293b" }}>{datos ? n : "…"}</span>
            </button>
          ))}
          <button onClick={() => { setSituacion("sin"); setVista("usuarios"); }} style={{
            display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 2, minWidth: 140, padding: "10px 14px", borderRadius: 14, cursor: "pointer",
            background: situacion === "sin" && vista === "usuarios" ? "#fee2e2" : "#fff", border: `2px solid ${situacion === "sin" && vista === "usuarios" ? "#b91c1c" : "#fca5a5"}`,
          }}>
            <span style={{ fontSize: 12.5, fontWeight: 700, color: "#b91c1c" }}>⚠️ Sin notificaciones</span>
            <span style={{ fontSize: 24, fontWeight: 900, color: "#1e293b" }}>{datos ? conteo.fallan + conteo.desactivadas + conteo.sin_activar : "…"}</span>
          </button>
          <button onClick={() => setVista("dispositivos")} style={{
            display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 2, minWidth: 140, padding: "10px 14px", borderRadius: 14, cursor: "pointer",
            background: vista === "dispositivos" ? "#e0f2fe" : "#fff", border: `2px solid ${vista === "dispositivos" ? "#0369a1" : "#e2e8f0"}`,
          }}>
            <span style={{ fontSize: 12.5, fontWeight: 700, color: "#0369a1" }}>📱 Dispositivos</span>
            <span style={{ fontSize: 24, fontWeight: 900, color: "#1e293b" }}>{datos ? dispositivos.length : "…"}</span>
            {compartidos > 0 && <span style={{ fontSize: 11.5, fontWeight: 800, color: "#9a3412", background: "#ffedd5", borderRadius: 999, padding: "1px 8px" }}>👥 {compartidos} compartido{compartidos !== 1 ? "s" : ""}</span>}
          </button>
        </div>

        {/* Vista + tipo + buscador */}
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", marginBottom: 10 }}>
          {[["usuarios", "👤 Por usuario"], ["dispositivos", "📱 Por dispositivo"]].map(([k, t]) => (
            <button key={k} onClick={() => setVista(k)} style={{ ...st.pill, ...(vista === k ? st.pillOn : {}) }}>{t}</button>
          ))}
          <span style={{ width: 1, height: 26, background: "#cbd5e1", margin: "0 4px" }} />
          {TIPOS.map(([k, t]) => (
            <button key={k} onClick={() => setTipo(k)} style={{ ...st.pill, ...(tipo === k ? st.pillOn : {}) }}>{t}</button>
          ))}
          <span style={{ width: 1, height: 26, background: "#cbd5e1", margin: "0 4px" }} />
          <button onClick={() => { setVista("usuarios"); setSituacion(situacion === "sin" ? "todas" : "sin"); }}
            style={{ ...st.pill, ...(situacion === "sin" ? { background: "#b91c1c", color: "#fff", borderColor: "#b91c1c" } : { borderColor: "#fca5a5", color: "#b91c1c" }) }}>
            ⚠️ Sin notificaciones{datos ? ` (${conteo.fallan + conteo.desactivadas + conteo.sin_activar})` : ""}
          </button>
        </div>
        <input value={busca} onChange={(e) => setBusca(e.target.value)} placeholder="🔍 Buscar usuario, nombre, móvil o titular…"
          style={{ width: "100%", boxSizing: "border-box", padding: "10px 14px", borderRadius: 12, border: "2px solid #c7d2fe", fontSize: 14, outline: "none", marginBottom: 12 }} />

        {/* Filtro por fecha de alta / baja (un día, o rango) + orden */}
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", marginBottom: 8, background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, padding: "8px 12px", fontSize: 13.5 }}>
          <span style={{ fontWeight: 800, color: "#334155" }}>📅 Fecha de</span>
          {[["alta", "🔔 Alta"], ["baja", "🔕 Baja"]].map(([k, t]) => (
            <button key={k} onClick={() => setCampoFecha(k)} style={{ ...st.mini, ...(campoFecha === k ? { background: "#1e3a5f", color: "#fff", borderColor: "#1e3a5f" } : {}) }}>{t}</button>
          ))}
          <label>{rango ? "desde" : "día"} <input type="date" value={dia} onChange={(e) => setDia(e.target.value)} style={st.fecha} /></label>
          <label style={{ display: "inline-flex", alignItems: "center", gap: 4, cursor: "pointer", fontWeight: 700, color: "#334155" }}>
            <input type="checkbox" checked={rango} onChange={(e) => { setRango(e.target.checked); if (!e.target.checked) setHasta(""); }} /> Rango
          </label>
          {rango && <label>hasta <input type="date" value={hasta} onChange={(e) => setHasta(e.target.value)} style={st.fecha} /></label>}
          {(dia || hasta) && <button onClick={() => { setDia(""); setHasta(""); }} style={{ ...st.mini, borderColor: "#fca5a5", color: "#b91c1c" }}>✕ Quitar fecha</button>}
          <span style={{ flex: 1 }} />
          {vista === "dispositivos" && (
            <label style={{ fontWeight: 700, color: "#334155" }}>Ordenar
              <select value={orden} onChange={(e) => setOrden(e.target.value)} style={{ ...st.fecha, marginLeft: 6 }}>
                <option value="defecto">Último registro primero</option>
                <option value="nombre_asc">Por nombre</option>
                <option value="alta_desc">Alta: más reciente primero</option>
                <option value="alta_asc">Alta: más antigua primero</option>
                <option value="baja_desc">Baja: más reciente primero</option>
                <option value="baja_asc">Baja: más antigua primero</option>
              </select>
            </label>
          )}
          {vista === "usuarios" && <span style={{ fontSize: 12, color: "#64748b" }}>Pulsa una cabecera de la tabla para ordenar</span>}
        </div>
        {datos && (
          <div style={{ fontSize: 13, color: "#334155", margin: "0 2px 10px", fontWeight: 700 }}>
            Mostrando {vista === "usuarios" ? `${listaUsuarios.length} de ${usuarios.length} usuarios` : `${listaDispositivos.length} de ${dispositivos.length} móviles`}
            {filtrandoFecha && (
              <span style={{ fontWeight: 500, color: "#64748b" }}>
                {" "}· {campoFecha === "alta" ? "alta" : "baja"} {rango && hasta ? `del ${fmt(dia).slice(0, 10)} al ${fmt(hasta).slice(0, 10)}` : `el ${fmt(dia).slice(0, 10)}`}
                {campoFecha === "baja" ? " (las bajas anteriores al 09/10/2026 no tienen fecha)" : ""}
              </span>
            )}
          </div>
        )}

        {!datos && !error && <div style={{ textAlign: "center", padding: 40, color: "#64748b" }}>Cargando…</div>}

        {datos && vista === "usuarios" && (
          <div style={{ background: "#fff", borderRadius: 14, overflowX: "auto", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14, minWidth: 620 }}>
              <thead>
                <tr style={{ background: "#3498db", color: "#fff" }}>
                  {[["nombre", "Usuario"], ["tipo", "Tipo"], ["situacion", "Notificaciones"], ["alta", "🔔 Alta"], ["baja", "🔕 Baja"], ["moviles", "Móviles registrados"], [null, ""]].map(([c, h]) => (
                    <th key={h || "acc"} style={{ ...st.th, cursor: c ? "pointer" : "default", userSelect: "none" }} onClick={c ? () => pulsarCabecera(c) : undefined} title={c ? "Ordenar" : undefined}>
                      {h}{c ? flecha(c) : ""}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {listaUsuarios.length === 0 ? (
                  <tr><td colSpan={7} style={{ padding: 30, textAlign: "center", color: "#94a3b8" }}>No hay usuarios en este filtro.</td></tr>
                ) : listaUsuarios.map((u, i) => (
                  <tr key={u.user} style={{ background: i % 2 ? "#fafafa" : "#fff", borderBottom: "1px solid #eef2f7" }}>
                    <td style={st.td}><strong>{u.nombre || u.user}</strong><div style={{ fontSize: 12, color: "#64748b" }}>@{u.user}</div></td>
                    <td style={{ ...st.td, textTransform: "capitalize" }}>{u.tipo}</td>
                    <td style={st.td}><Chip c={SITUACION[u.situacion]} extra={u.situacion === "activas" ? `${u.moviles_activos} móvil${u.moviles_activos !== 1 ? "es" : ""}` : null} /></td>
                    <td style={{ ...st.td, fontSize: 12.5, whiteSpace: "nowrap", color: u.fecha_alta ? "#15803d" : "#94a3b8" }}>{u.fecha_alta ? fmt(u.fecha_alta) : "—"}</td>
                    <td style={{ ...st.td, fontSize: 12.5, whiteSpace: "nowrap", color: u.fecha_baja ? "#b91c1c" : "#94a3b8" }}>{u.fecha_baja ? fmt(u.fecha_baja) : "—"}</td>
                    <td style={{ ...st.td, color: "#475569" }}>{u.moviles || "—"}</td>
                    <td style={st.td}>
                      {u.moviles > 0 ? (
                        <button onClick={() => { setBusca(u.user); setVista("dispositivos"); }} style={st.mini}>📱 Ver móviles</button>
                      ) : (
                        <span style={{ fontSize: 12, color: "#94a3b8" }} title="Las tiene que activar la persona desde su móvil (aviso naranja de su pantalla principal)">Lo activa ella en su móvil</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {datos && vista === "dispositivos" && (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(330px, 1fr))", gap: 12 }}>
            {listaDispositivos.length === 0 && <div style={{ color: "#94a3b8", padding: 20 }}>No hay dispositivos en este filtro.</div>}
            {listaDispositivos.map((d) => {
              const activos = d.usuarios.filter((u) => u.estado === 1).length;
              return (
                <div key={d.device_id} style={{ background: "#fff", borderRadius: 14, padding: "12px 14px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", border: `2px solid ${activos > 1 ? "#fdba74" : activos ? "#bbf7d0" : "#e2e8f0"}` }}>
                  <Titular key={d.titular || ""} d={d} onCambiado={cargar} />
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <span style={{ fontSize: 24 }}>📱</span>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: 900, color: "#1e293b" }}>{d.modelo ? `${d.modelo}` : `Móvil ${d.device_id.slice(0, 8)}`}</div>
                      <div style={{ fontSize: 12, color: "#475569" }}>{infoMovil(d) || <span style={{ color: "#94a3b8" }}>Sin datos del móvil todavía (se rellenan cuando abra la app)</span>}</div>
                      <div style={{ fontSize: 11.5, color: "#94a3b8" }}>{d.servicio} · registrado {fmt(d.ultimo_registro)}{d.ultima_conexion ? ` · última conexión ${fmt(d.ultima_conexion)}` : ""} · id {d.device_id.slice(0, 8)}</div>
                    </div>
                    {activos > 1 && <span style={{ fontSize: 11.5, fontWeight: 800, color: "#9a3412", background: "#ffedd5", borderRadius: 999, padding: "2px 8px" }}>👥 Compartido</span>}
                  </div>
                  <div style={{ display: "grid", gap: 6, marginTop: 10 }}>
                    {d.usuarios.map((u) => (
                      <div key={u.user} style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", background: "#f8fafc", borderRadius: 10, padding: "6px 9px" }}>
                        <div style={{ flex: 1, minWidth: 120 }}>
                          <strong style={{ fontSize: 13.5 }}>{u.nombre || u.user}</strong>
                          <span style={{ fontSize: 12, color: "#64748b" }}> · @{u.user}{u.tipo ? ` · ${u.tipo}` : ""}{u.usuario_activo ? "" : " · usuario de baja"}</span>
                          <FechasAltaBaja estado={u.estado} alta={u.fecha} baja={u.fecha_baja} />
                          {u.error_push && u.error_push.falla && (
                            <div style={{ marginTop: 4, background: "#fef3c7", border: "1px solid #fcd34d", color: "#92400e", borderRadius: 8, padding: "4px 8px", fontSize: 12, fontWeight: 700 }}>
                              ⚠️ No le llegan: su móvil no consigue suscribirse ({u.error_push.n_7d} fallo{u.error_push.n_7d === 1 ? "" : "s"} en 7 días, último {fmt(u.error_push.ultima)})
                              <div style={{ fontWeight: 500, color: "#a16207" }}>{u.error_push.error}</div>
                            </div>
                          )}
                          {u.error_push && !u.error_push.falla && (
                            <div style={{ marginTop: 3, fontSize: 11.5, color: "#94a3b8" }}>
                              Tuvo {u.error_push.n_7d} fallo{u.error_push.n_7d === 1 ? "" : "s"} esta semana (último {fmt(u.error_push.ultima)}), luego se registró bien
                            </div>
                          )}
                        </div>
                        <Chip c={u.error_push && u.error_push.falla ? { txt: "No le llegan", icono: "⚠️", fg: "#b45309", bg: "#fef3c7" } : (ESTADO_DISP[u.estado] || ESTADO_DISP[0])} />
                        {u.estado === 1
                          ? <button onClick={() => setConfirmar({ accion: "quitar", u, d })} style={{ ...st.mini, borderColor: "#fca5a5", color: "#b91c1c" }}>🔕 Quitar</button>
                          : <button onClick={() => setConfirmar({ accion: "activar", u, d })} style={{ ...st.mini, borderColor: "#86efac", color: "#15803d" }}>🔔 Activar</button>}
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

const st = {
  btnCab: { background: "rgba(255,255,255,0.15)", border: "none", borderRadius: 8, color: "#fff", fontWeight: 700, cursor: "pointer", padding: "8px 14px" },
  pill: { border: "2px solid #e2e8f0", background: "#fff", color: "#334155", borderRadius: 999, padding: "6px 14px", fontWeight: 700, fontSize: 13.5, cursor: "pointer" },
  pillOn: { background: "#1e3a5f", color: "#fff", borderColor: "#1e3a5f" },
  th: { padding: "11px 10px", textAlign: "left", fontWeight: 700, whiteSpace: "nowrap" },
  td: { padding: "10px 10px", verticalAlign: "middle" },
  fecha: { padding: "5px 8px", borderRadius: 8, border: "1px solid #cbd5e1", fontSize: 13.5 },
  mini: { border: "2px solid #c7d2fe", background: "#fff", color: "#3730a3", borderRadius: 10, padding: "4px 10px", fontWeight: 800, fontSize: 12.5, cursor: "pointer", whiteSpace: "nowrap" },
};
